export enum AppContentType {
  HoTroThanhToan = 1,
  DieuKhoan = 2,
  BaoMat = 3,
  LienHe = 4,
}
